import React,{useEffect} from "react";
import { Grid } from "@mui/material";
import Proptypes from "prop-types";
import "../LoanAgreement/LoanAgreement.css";
import moment from "moment";
import { ImageBaseUrl } from "../../Environment";
import { getSecureItem } from "../../utilsFunctions";
import { SignatureLabels } from "../../Constants/SignatureLabels";

export const LoanSanctionLetter = ({ branchAddress = null, data, printRef, language, signatureType }) => {
  const countryCode = getSecureItem("country")?.code;
  const countryCurrency = getSecureItem("country")?.symbol;

  const companyData = data?.company;
  const userData = data?.user;
  const customerData = data?.customer;
  const customerDataAddresses = data?.customer?.addresses[0];
  const customerDataBankDetail = data?.customer?.bankDetail;
  const customerDataCoApplicant = data?.customer?.coApplicant;
  const customerDataNominee = data?.customer?.nominee;
  const customerDataGuarantor = data?.customer?.guarantor;
  const customerDataLoanType = data?.loanType;
  const customerProfilePic = data?.customer?.proofs?.find(p => p.proofType === "profilepic")?.proofImagePath;
  const customerSignaturePic = data?.customer?.proofs?.find(p => p.proofType === "uploadSignature")?.proofImagePath;
  const AdminSignature =
    companyData?.users?.find(
      u =>
        u.userType === "Admin" &&
        u.branchId === data?.customer?.branchId &&
        u.userSignaturePath
    )?.userSignaturePath ||
    companyData?.users?.find(
      u => u.userType === "superAdmin" && u.userSignaturePath
    )?.userSignaturePath ||
    null;

  const firstLoanCollection = data?.loanCollections[0];

  const {
    loanTenureType,
    loanTenure,
    collectionAmount,
    loanAmount,
    totalAmountToCollect,
    loanId,
    processFee,
    feeDetailsJson,
  } = data;

      useEffect(() => {
      const customerName = `${customerData?.firstName ?? ""} ${customerData?.lastName ?? ""}`.trim();
      document.title = `Loan Sanction Letter - ${customerName || "Customer"}`;
  
      return () => {
        document.title = "LendStack - Forging Digital OneOffice for Micro Business";
      };
    }, [customerData]);

  const getAddress = (address) =>
    [
      address?.AddressStreet,
      address?.AddressLandmark,
      address?.AddressCity,
      address?.AddressState,
      address?.AddressPincode,
    ]
      .filter(Boolean)
      .join(", ");

  const customerAddress = (address) =>
    [address?.AddressStreet, address?.AddressLandmark]
      .filter(Boolean)
      .join(", ");

  const customerAddress2 = (address) =>
    [address?.AddressCity, address?.AddressState, address?.AddressPincode]
      .filter(Boolean)
      .join(", ");
  return (
    <div ref={printRef} className="loan-agreement">
      <Grid container>
        <Grid
          item
          xs={12}
          sm={2}
          md={2}
          paddingX={2}
          style={{ border: "1px solid black" }}
        >
          <div className="header-left">
            { companyData?.profilePic ? (
              <img
                src={
                  getSecureItem("loggedinUserCompany") == "1365"
                    ? "https://i.imghippo.com/files/CCD2780qQ.jpeg"
                    : `${ImageBaseUrl}${ companyData?.profilePic}`
                }
                alt="Logo"
                className="logo"
              />
            ) : (
              <div
                style={{
                  height: "120px",
                }}
              ></div>
            )}
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={8}
          md={8}
          paddingX={2}
          style={{ border: "1px solid black", borderRightWidth: "0px" }}
        >
          <div className="header-right">
            <h1>{companyData?.companyName}</h1>
            <p>
              <strong>Address: </strong> {branchAddress ? branchAddress : getAddress(companyData)}
              <br />
              <strong>GSTIN: </strong> {companyData?.GstIn || ""} |{" "}
              <strong>CIN: </strong> {companyData?.CIN || ""} |{" "}
              <strong>Website: </strong> {companyData?.companyWebsite || ""}
              <br />
              <strong>Mobile No: </strong> {companyData?.phone}{" "}
              <strong>| Email ID: </strong> {companyData?.companyMail}
            </p>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={2}
          md={2}
          paddingX={2}
          style={{ border: "1px solid black", borderLeftWidth: "0px" }}
        />
      </Grid>
      <h2 className="title">Loan Sanction Letter</h2>
      <div style={{marginBottom: 10}} align="right">
        <span className="Fonts">All amounts are in {countryCurrency}.</span>
      </div>
      <div className="content">
        <div className="section">
          <table className="info-table">
            <tbody>
              <tr>
                <td colspan={2}>
                  <strong>Branch : </strong> <br />{" "}
                  <strong>Branch Center : </strong>
                </td>
                <td colspan={2}>
                  <strong>Date : </strong>
                  {moment().format("DD-MM-YYYY")} |{" "}
                  <strong>First EMI Date : </strong>
                  {moment(firstLoanCollection?.dueDate).format("DD-MM-YYYY")}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Customer Name</strong> <br />{" "}
                  {customerData?.firstName + ` (${customerData?.cust_id})`}
                </td>
                <td>
                  <strong>Address</strong> <br />{" "}
                  {customerAddress(customerDataAddresses)}
                </td>
                <td>
                  <strong>District/State</strong> <br />{" "}
                  {customerAddress2(customerDataAddresses)}
                </td>
                <td rowSpan={3}>
                  <div className="imgBox">
                    {customerProfilePic && (
                      <img
                        src={`${ImageBaseUrl}${customerProfilePic}`}
                        alt="Customer"
                        className="profileImg"
                      />
                    )}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Contact No</strong> <br /> {customerData?.phone}
                </td>
                <td>
                  <strong>Gender : </strong> {customerData?.gender}
                  <br /> <strong>DOB : </strong>
                  {customerData?.dob && moment(customerData?.dob).format("DD-MM-YYYY")}
                </td>
                <td>
                  <strong>C/O</strong> <br /> {customerData?.fatherName}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Co-Applicant : </strong> <br />{" "}
                  {customerDataCoApplicant?.coApplicantName}
                </td>
                <td>
                  <strong>Co-Applicant Address : </strong> <br />{" "}
                  {customerDataCoApplicant?.coApplicantAddress}
                </td>
                <td>
                  <strong>Co-Applicant Phone : </strong> <br />{" "}
                  {customerDataCoApplicant?.coApplicantMobNo}
                </td>
              </tr>
              <tr>
                <td colspan={2}>
                  <h3>Bank Details</h3>
                </td>
                <td colspan={2}>
                  <h3>Applied Loan Details</h3>
                </td>
              </tr>

              <tr>
                <td>Bank : {customerDataBankDetail?.bankName}</td>
                <td>Branch : {customerDataBankDetail?.bankBranch}</td>
                <td>Loan ID : {loanId}</td>
                <td>Processing Fee : {processFee}</td>
              </tr>
              <tr>
                <td>
                  Account Number : {customerDataBankDetail?.accountNumber}
                </td>
                <td>Account Type : {customerDataBankDetail?.accountType}</td>
                <td>
                  Amount to be Paid :{" "}
                  {totalAmountToCollect}
                </td>
                <td>
                  Additional Fee
                  {feeDetailsJson &&
                    Object.entries(feeDetailsJson)
                      .filter(([key]) => key !== "totalFee")
                      .map(([key, value]) => (
                        <div key={key}>
                          {key}: {countryCurrency} {value}
                        </div>
                      ))}
                </td>
              </tr>
              <tr>
                <td>Account Holder : {customerDataBankDetail?.acHolderName}</td>
                <td>IFSC : {customerDataBankDetail?.ifsc}</td>
                <td>Loan Amount : {loanAmount}</td>
                <td>Interest Amount : {Number(totalAmountToCollect)-loanAmount}</td>
              </tr>
              <tr>
                <td colspan={2}>
                  <h3>Income Details</h3>
                </td>
                <td>Loan Type : {customerDataLoanType?.loanType}</td>
                <td>Installment Amount : {collectionAmount}</td>
              </tr>

              <tr>
                <td>Income (INR) : {customerData?.annualIncome}</td>
                <td>Occupation : {customerData?.incomeSource}</td>
                <td>Recovery type : {loanTenureType}</td>
                <td>No of Payments : {loanTenure}</td>
              </tr>
              <tr>
                <td colspan={3}>
                  <h3>Guarantor Details</h3>
                </td>
                <td rowSpan={3}>
                  <div className="imgBox" />
                </td>
              </tr>
              <tr>
                <td>Name : {customerDataGuarantor?.guarantorName}</td>
                <td>Address : {customerDataGuarantor?.guarantorAddress}</td>
                <td>
                  Contact Number : {customerDataGuarantor?.guarantorMobNo}
                </td>
              </tr>
              {getSecureItem("loggedinUserCompany") === "3310" ? null : (<tr>
                <td>Nominee Name : {customerDataNominee?.nomineeName}</td>
                <td>Nominee Mobile : {customerDataNominee?.nomineeMobNo}</td>
                <td>
                  Nominee DOB :{" "}
                  {moment(customerDataNominee?.nomineeDOB).format("DD-MM-YYYY")}
                </td>
              </tr>)}
            </tbody>
          </table>
        </div>

        <div className="footer section">
          <table
            className="footer-table"
            style={{ width: "100%", borderCollapse: "collapse" }}
          >
            <tbody>
              <tr>
                <td style={{ border: "1px solid black", textAlign: "center" }}>
                  {countryCode == '91' ? 
                    <strong>
                      {SignatureLabels.memberSignature.en}
                      <br />
                      {SignatureLabels.memberSignature[language]}
                    </strong> : 
                    <strong> {SignatureLabels.memberSignature.en}
                    </strong>}
                  <br />
                  {signatureType && customerSignaturePic ? (
                    <img src={`${ImageBaseUrl}${customerSignaturePic}`} alt="Member Signature" style={{ maxWidth: "100%", maxHeight: "60px", objectFit: "contain", marginTop: 10 }} />
                  ) : (
                    <span style={{ marginTop: 30 }} className="input-line"></span>
                  )}
                </td>
                <td style={{ border: "1px solid black", textAlign: "center" }}>
                  {countryCode == '91' ?
                    <strong>
                      {SignatureLabels.guarantorSignature.en}
                      <br />
                      {SignatureLabels.guarantorSignature[language]}
                    </strong> : 
                    <strong> {SignatureLabels.guarantorSignature.en}
                    </strong>}
                  <br />
                  <span style={{ marginTop: 30 }} className="input-line"></span>
                </td>
                <td style={{ border: "1px solid black", textAlign: "center" }}>
                  {countryCode == '91' ?
                    <strong>
                      {SignatureLabels.branchSealSignature.en}
                      <br />
                      {SignatureLabels.branchSealSignature[language]}
                    </strong> : 
                    <strong> {SignatureLabels.branchSealSignature.en}
                    </strong>}
                  <br />
                  {signatureType && AdminSignature ? (
                    <img src={`${ImageBaseUrl}${AdminSignature}`} alt="Authorized Signature" style={{ maxWidth: "100%", maxHeight: "60px", objectFit: "contain", marginTop: 10 }} />
                  ) : (
                    <span style={{ marginTop: 30 }} className="input-line"></span>
                  )}
                </td>
                <td style={{ border: "1px solid black", textAlign: "center" }}>
                  {countryCode == '91' ?
                    <strong>
                      {SignatureLabels.companySealSignature.en}
                      <br />
                      {SignatureLabels.companySealSignature[language]}
                    </strong> :
                    <strong> {SignatureLabels.companySealSignature.en}
                    </strong>}
                  <br />
                  {signatureType && companyData?.signature ? (
                    <img src={`${ImageBaseUrl}${companyData?.signature}`} alt="Authorized Signature" style={{ maxWidth: "100%", maxHeight: "60px", objectFit: "contain", marginTop: 10 }} />
                  ) : (
                    <span style={{ marginTop: 30 }} className="input-line"></span>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

LoanSanctionLetter.prototype = {
  data: Proptypes.any,
  printRef: Proptypes.any,
};
